import { render, staticRenderFns } from "./ehc-admin.vue?vue&type=template&id=700a29f8&scoped=true"
import script from "./ehc-admin.vue?vue&type=script&lang=js"
export * from "./ehc-admin.vue?vue&type=script&lang=js"
import style0 from "./ehc-admin.vue?vue&type=style&index=0&id=700a29f8&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a29f8",
  null
  
)

export default component.exports